import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from 'components/HookForm';
import { updateSmartSpot as updateSmartSpotAction } from 'components/SmartSpot';
import { SMARTSPOT_REASON } from 'constants/logic';
import { SMARTSPOT_UPDATE_SOURCE } from 'constants/tracking';
import { selectActiveVenue, selectVenueSmartspotData } from 'selectors/general';
import { trackMinimumSpotsUpdated } from './SmartTools.helpers';

import SmartSpotOnboardingMinimumSpots from './SmartSpotOnboardingMinimumSpots';

const SmartSpotOnboardingMinimumSpotsForm = ({
  formName,
  isLoading,
  countryCode,
  handleLearnMore,
  onSkip,
  onDone,
  showSelectOptionPeakTime,
  showSelectOptionOffPeakTime,
}) => {
  const dispatch = useDispatch();
  const venueData = useSelector(selectActiveVenue);
  const { venueId, venueName, venueSubtitle } = venueData;
  const { minimumSpotsPeakTime, minimumSpotsOffpeakTime, isEnabled } = useSelector(state =>
    selectVenueSmartspotData(state)
  );

  const initialValues = {
    minimumSpotsPeakTime: minimumSpotsPeakTime || 0,
    minimumSpotsOffpeakTime: minimumSpotsOffpeakTime || 0,
  };

  const handleSubmit = (formValues, formAsyncFns) => {
    const { minimumSpotsPeakTime: formMinimumSpotsPeakTime, minimumSpotsOffpeakTime: formMinimumSpotsOffpeakTime } =
      formValues;

    const values = {
      isEnabled,
      minimumSpotsPeakTime: formMinimumSpotsPeakTime,
      minimumSpotsOffpeakTime: formMinimumSpotsOffpeakTime,
    };

    trackMinimumSpotsUpdated(venueId, formMinimumSpotsPeakTime, formMinimumSpotsOffpeakTime, initialValues);

    const meta = {
      venueId,
      venueName,
      venueSubtitle,
      reason: SMARTSPOT_REASON.GENERIC_UPDATE,
      source: SMARTSPOT_UPDATE_SOURCE.SMART_TOOLS,
    };

    return dispatch(updateSmartSpotAction(values, meta, formAsyncFns));
  };

  return (
    <Form id={formName} defaultValues={initialValues} isLoading={isLoading} onSubmit={handleSubmit}>
      {function FormRender({ control, submit, formState }) {
        const { isSubmitting, isDirty } = formState;

        const isDoneDisabled =
          (minimumSpotsPeakTime === null || minimumSpotsPeakTime === 0) &&
          (minimumSpotsOffpeakTime === null || minimumSpotsOffpeakTime === 0) &&
          !isDirty;

        const handleDone = async () => {
          await submit();
          onDone();
        };

        return (
          <SmartSpotOnboardingMinimumSpots
            control={control}
            countryCode={countryCode}
            handleLearnMore={handleLearnMore}
            onSkip={onSkip}
            onNext={handleDone}
            isSubmitting={isSubmitting}
            isDoneDisabled={isDoneDisabled}
            showSelectOptionPeakTime={showSelectOptionPeakTime}
            showSelectOptionOffPeakTime={showSelectOptionOffPeakTime}
          />
        );
      }}
    </Form>
  );
};

SmartSpotOnboardingMinimumSpotsForm.propTypes = {
  formName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  countryCode: PropTypes.string,
  handleLearnMore: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  showSelectOptionPeakTime: PropTypes.bool.isRequired,
  showSelectOptionOffPeakTime: PropTypes.bool.isRequired,
};

export default SmartSpotOnboardingMinimumSpotsForm;
